import { FormControl } from '@angular/forms';

export class ValidationResult {
    [key: string]: boolean;
}
export class PasswordValidator {
    public static strong(control: FormControl): ValidationResult {
        let valid = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{12,50}$/.test(control.value);
        if (!valid) {
            return { strong: true };
        }
        return {};
    }
}